import { render, staticRenderFns } from "./PriceAnalytics.vue?vue&type=template&id=cd6e2c4c&scoped=true&"
import script from "./PriceAnalytics.vue?vue&type=script&lang=js&"
export * from "./PriceAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./PriceAnalytics.vue?vue&type=style&index=0&id=cd6e2c4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd6e2c4c",
  null
  
)

export default component.exports